import { get } from 'axios';

export const getTickets = async bookingRef => {
  const { data } = await get(`/api/package/${bookingRef}/tickets`);
  return {
    bookingRef,
    events: data.events,
  };
};

export const getTicketsAvailability = async bookingRef => {
  const { data } = await get(
    `/api/4.0/package/${bookingRef}/ticketavailability`,
  );

  return {
    ...data,
    bookingRef,
  };
};

export const getTicketAllocations = async bookingId => {
  const { data } = await get(`/api/4.0/ticket/bookingAllocations/${bookingId}`);

  return data;
};
